import { useMemo, type PropsWithChildren } from 'react';

import type { DataTableRowData } from '../../row-data-types.js';
import type { DataTableOptions } from '../types/table.types.js';
import { getMinMaxForGanttColumns } from './GanttChart.js';

/**
 * Configuration hook for the DataTable Gantt Chart feature.
 * @internal
 */
export function useGanttChart<TData extends DataTableRowData>(
  _props: PropsWithChildren,
  options: DataTableOptions<Exclude<TData, unknown>>,
): void {
  const ganttMinMaxValues = useMemo(
    () =>
      getMinMaxForGanttColumns<Exclude<TData, unknown>>(
        options.data,
        options.columns,
        options.getSubRows,
      ),
    [options.columns, options.data, options.getSubRows],
  );

  // oxlint-disable-next-line react/immutability
  options.state = {
    ...options.state,
    ganttMinMaxValues,
  };
}
